/**
 * Query keys for deployments and provisioning.
 *
 * A small factory rather than more hand-written arrays: the provisioning UI
 * invalidates `detail(id)` from four places, and a typo in one of those copies
 * fails silently as a stale badge rather than as an error.
 *
 * The first four values are byte-identical to the literals the deployment
 * pages used before, so nothing else's invalidation breaks.
 */
export const deploymentKeys = {
    all: () => ['deployments'] as const,
    list: () => ['deployments', 'all'] as const,
    availableSubscriptions: () => ['deployments', 'available-subscriptions'] as const,
    detail: (id: string | undefined) => ['deployment', id] as const,

    provisioningJobs: (deploymentId: string | undefined) =>
        ['deployment', deploymentId, 'provisioning-jobs'] as const,
    provisioningJob: (jobId: string | undefined) =>
        ['provisioning-job', jobId] as const,
    provisioningLog: (jobId: string | undefined) =>
        ['provisioning-log', jobId] as const,
    sshCredential: (deploymentId: string | undefined) =>
        ['deployment', deploymentId, 'ssh-credential'] as const,
};
